import React from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
import { isSet } from '../../../../Utils/CommonFunctions';
import Buttons from '../../../UI/Buttons';
// import Wrp from '../../../hoc/Wrp/Wrp';


const GridActionWithCheckBox = (props) =>{
  const {colData,id,header} = props;
      const checkBox = colData.checkBox;
      const editAction = colData.tableAction;
      const eventsHandler = {
        onChange:() => (checkBox.changeHandler) ?
                     checkBox.changeHandler(checkBox,checkBox.attributes):
                      ()=>{}
      }
    //   console.log('checkbox...',eventsHandler,header.attributes,checkBox.attributes);
        return(
            <th key={"column"+id} style={{width:'20px'}}>
                <input 
                    {...eventsHandler}
                    {...isSet(header.attributes,{})} 
                    {...isSet(checkBox.attributes,{})}
                    className="form-radio-input m-2" 
                    type="checkbox" 
                    checked={(checkBox.checked===true)?true:false}
                    name="checkbbox" 
                    value=""></input>
                <Buttons buttonList={editAction} key={"btn"+id}/>
            </th>
        );

}

// const isDiffProps = (prevProps,nextProps)=>{
//   //JSON.stringify(prevProps.colData.checked)===JSON.stringify(nextProps.colData.checked)
//   console.log('prevPROO',prevProps.colData.checkBox.checked,nextProps.colData.checkBox.checked)
//   if(JSON.stringify(prevProps.colData)===JSON.stringify(nextProps.colData)){
//     return true;
//   }
// } 

export default GridActionWithCheckBox;